import { IconProps } from './types';

export const UmbrellaIcon = ({ title = 'Umbrella Icon', ...props }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 42 42" {...props}>
        <title>{title}</title>
        <path
            fill="#0A2F73"
            d="M34.195 36.538 23.082 25.425l2.45-2.45 11.113 11.113zm-23.888-1.225q-4.375-4.288-5.14-10.063-.766-5.775 1.99-10.806.131 1.487.744 3.347.612 1.86 1.684 3.915a41 41 0 0 0 2.56 4.222 51 51 0 0 0 3.28 4.266zm7.525-7.525a27 27 0 0 1-3.675-4.572q-1.575-2.472-2.472-4.79-.897-2.32-1.006-4.223-.11-1.903.81-2.822.918-.962 2.821-.875 1.904.088 4.244.985t4.812 2.494a27.7 27.7 0 0 1 4.572 3.696zm12.513-12.513a41 41 0 0 0-4.222-3.237 52 52 0 0 0-4.2-2.538q-2.035-1.094-3.894-1.728-1.86-.634-3.347-.766 5.031-2.625 10.784-1.815t9.954 5.01z"
        ></path>
        <path
            fill="#FB0"
            d="M17.832 27.788a27 27 0 0 1-3.675-4.572q-1.575-2.472-2.472-4.79-.897-2.32-1.006-4.223-.11-1.903.81-2.822.918-.962 2.821-.875 1.903.088 4.244.985t4.812 2.494a27.7 27.7 0 0 1 4.572 3.696z"
        ></path>
    </svg>
);
